import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import {
  IconDashboard,
  IconWorkflow,
  IconCalendar,
  IconHistory,
  IconServer,
  IconBraces,
  IconPackage,
  IconUsers,
  IconShieldCheck,
  IconSettings,
  IconClipboard,
  IconKey,
} from './icons';
import type { ComponentType } from 'react';

interface NavItem {
  to: string;
  label: string;
  icon: ComponentType<{ size?: number }>;
  requires?: string;
}

const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'Dashboard', icon: IconDashboard },
  { to: '/flows', label: 'Flows', icon: IconWorkflow },
  { to: '/agendamentos', label: 'Agendamentos', icon: IconCalendar },
  { to: '/execucoes', label: 'Execuções', icon: IconHistory },
  { to: '/work-pools', label: 'Work Pools', icon: IconServer, requires: 'infra.manage' },
  { to: '/variables', label: 'Variables', icon: IconBraces, requires: 'config.manage' },
  { to: '/blocks', label: 'Blocks', icon: IconPackage, requires: 'config.manage' },
  { to: '/api-keys', label: 'API Keys', icon: IconKey },
  { to: '/admin/users', label: 'Usuarios', icon: IconUsers, requires: 'admin.users.manage' },
  { to: '/admin/flow-permissions', label: 'Permissoes', icon: IconShieldCheck, requires: 'admin.flows.permissions.manage' },
  { to: '/admin/audit', label: 'Audit Log', icon: IconClipboard, requires: 'admin.users.manage' },
  { to: '/admin/entra', label: 'Entra ID', icon: IconSettings, requires: 'admin.users.manage' },
];

export function Layout() {
  const { me, logout, hasPermission } = useAuth();
  const navigate = useNavigate();

  const onLogout = () => {
    logout();
    navigate('/login');
  };

  const visibleNav = NAV_ITEMS.filter((i) => !i.requires || hasPermission(i.requires));

  return (
    <div className="layout">
      <aside className="layout-sidebar">
        <div className="brand">
          <strong>Portal Prefect</strong>
          <span className="brand-sub">governanca</span>
        </div>
        <nav className="layout-nav">
          {visibleNav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            >
              <item.icon size={16} />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="layout-user">
          <div className="user-name">{me?.user.displayName}</div>
          <div className="user-email">{me?.user.email}</div>
          <div className="user-roles">
            {me?.roles.map((r) => (
              <span key={r} className="badge">
                {r}
              </span>
            ))}
          </div>
          <button onClick={onLogout} className="btn btn-ghost btn-sm logout-btn">
            Sair
          </button>
        </div>
      </aside>
      <main className="layout-main">
        <Outlet />
      </main>
    </div>
  );
}
